import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import CustomerStats from '../../components/CustomerStats';
import FiltersPartial from './FiltersPartial';
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { updateQueryParams, selectQueryParams } from "../../ui/customerListingReducer";
import { useSelector } from "react-redux";

const Index = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };
  const [cvs, setCvs] = useState({});
  const [filtersModel, setFiltersModel] = useState(useSelector(selectQueryParams)["filters"]);

  // const [filtersModel, setFiltersModel] = useState({
  //   status: ['submitted', 'pending', 'accepted']
  // });
  const [cvListing] = getApi('chargingVerifications');

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'cus_nomenclature_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'RMN',
      value: (row) => {
        return <div>
          {row.mobile_number.map((number)=> <div key={number}>{number}</div>)}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Activation Date',
      attr: 'activated_at',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Offer',
      attr: 'offer_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      attr: 'branch_name',
      disableSort: true
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_customer.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
              <FontAwesomeIcon icon={faEye} />
            </div>
          </UiAction>
        </div>
      }
    },
  ]

  const onViewClick = (id) => {
    navigate(`/customers/${id}`)
  }

  // const onGetRmnClick = async (e) => {
  //   e.preventDefault();
  //   const id = e.target.dataset['id'];
  //   try {
  //     const response = await cvListing({ user_id: id }).unwrap();
  //     const charging_verifications = response.data.charging_verifications
  //     const userCvs = { [id]: charging_verifications };
  //     setCvs({ ...cvs, ...userCvs });
  //   } catch (error) {

  //   }
  // }

  return <>
    <ListingPageComponent
      key={PAGES.CustomersListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.CustomersListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Customers' }]}
      listingMutation={getApi('customers')}
      className="customers-listing-page"
      contentHeading="Customer List - Results"
      headers={headers}
      recordsKey="customers"
      contentTop={<CustomerStats />}
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
      searchBy={['ID', 'Name']}
  />
  </>
};

export default Index;
